import React from 'react';
import Panel from "../container/Panel";
import UploadForm from "../components/UploadForm";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";

const Edit = () => {
    const {t} = useTranslation("uploadForm")
    const location = useLocation();
    let document = location.state?.document

    return (
        <Panel title={t("Document edit")}>
            <UploadForm
                t={t}
                doc={document}
                referenceDataApiPath="/uploadform/referencedata"
            />
        </Panel>
    )
}

export default Edit;